import { urlRegex } from 'Constants/index'
import { atom, selector } from 'recoil'
import { ORDERBY_NAME } from '../actions/actions'

export const INPUT_VALUE_CUSTOM_URL = 'customUrl'
export const INPUT_VALUE_LANDING_PAGE = 'landingPageUrl'

export const inputState = atom({
  key: 'UrlSelection__inputState',
  default: {
    radioValue: INPUT_VALUE_CUSTOM_URL,
    url: '',
    lp: undefined,
    orderBy: ORDERBY_NAME,
    trackDetails: true,
    isDirty: false
  }
})

export const dirtyState = atom({
  key: 'UrlSelection__dirtyState',
  default: {
    urlDirty: false,
    lpDirty: false
  }
})

export const isInputInvalidState = selector({
  key: 'UrlSelection__isInputInvalidState',
  get: ({ get }) => {
    const { url, isDirty, radioValue, lp } = get(inputState)
    const { urlDirty } = get(dirtyState)

    if (!isDirty && radioValue !== INPUT_VALUE_LANDING_PAGE) return false

    if (
      urlDirty &&
      radioValue === INPUT_VALUE_CUSTOM_URL &&
      url.trim.length === 0 &&
      !urlRegex.test(url)
    ) {
      return true
    } else if (radioValue === INPUT_VALUE_LANDING_PAGE) {
      if (!lp) {
        return true
      }
    }
    return false
  }
})

export const isButtonDisabledState = selector({
  key: 'UrlSelection__isButtonDisabledState',
  get: ({ get }) => {
    const isInvalid = get(isInputInvalidState)
    const { url, radioValue, lp } = get(inputState)

    if (radioValue === INPUT_VALUE_LANDING_PAGE) {
      if (!lp) {
        return true
      } else {
        return false
      }
    } else if (radioValue === INPUT_VALUE_CUSTOM_URL) {
      if (isInvalid) {
        return true
      } else if (!url || url.trim().length === 0) {
        return true
      } else {
        return false
      }
    }
  }
})
